import { RouterProvider } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { loadAppCustomizationsData, selectAppInfo } from './services/utils/appInfoSlice';
import { checkUserAuth, selectAppAuth } from "./services/auth/authSlice";
import { ErrorBoundary } from "react-error-boundary";
import ReactGA from "react-ga4";

import './App.css'
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import './components/Form.css'
import 'animate.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


//import app router from features
import {router} from './features/Router/appRouter'
import GlobalFontStyle from "./fonts/fonts";
import ErrorScreen from "./screens/ErrorScreen/ErrorScreen";


// Ass RouterProvider to the app
export default function App() {

  const dispatch = useDispatch();
  const userAuth = useSelector(selectAppAuth)
  const appInfo = useSelector(selectAppInfo)

  useEffect(()=>{
    //load customizations data for tenant
    if(!appInfo.is_default)
      dispatch(loadAppCustomizationsData())
  },[])

  useEffect(()=>{
    //load user data when token available
    if(userAuth.refresh_auth && !userAuth.auth_token){
      dispatch(checkUserAuth())
    }
    ReactGA.initialize("G-X2QLJBKBCW");
  },[])

  return (
    <div id="App">
      <GlobalFontStyle />
      <ToastContainer />
      <ErrorBoundary  FallbackComponent={ErrorFallback} onReset={() => window.location.reload()}>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </div>
  )
}

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div role="alert" style={{ textAlign: "center", padding: "20px" }}>
      <h2>Oops! Qualcosa è andato storto 😵</h2>
      <p style={{ color: "red" }}>{error.message}</p>
      <button onClick={resetErrorBoundary}>Riprova</button>
    </div>
  );
}

